import React, { useState } from 'react';
import { TextField } from 'housecall-ui';
import { Suite } from 'vest';

type Props = {
  onClick: () => void;
  validation: Suite<(value: string) => void>;
  dataTestId: string;
  name: string;
  label: string;
  fullWidth: boolean;
  autoComplete: string;
  inputRef: React.RefObject<HTMLInputElement>;
};

const ENTER_KEY = 'Enter';

export const WrappedTextField = ({ onClick, validation, dataTestId, ...rest }: Props) => {
  const [touched, setTouched] = useState<boolean>(false);
  const [value, setValue] = useState<string>('');

  const hasError = () => {
    const { isValid } = validation(value);
    return touched && !isValid();
  };

  const getErrorMessage = () => {
    const { getErrors } = validation(value);
    const errors = getErrors().zipCode;
    if (touched && errors) {
      return errors[0];
    }
    return '';
  };
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = event.target;
    setValue(inputValue);
  };
  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === ENTER_KEY) {
      setTouched(true);
      event.preventDefault();
      if (value) {
        onClick();
      }
    }
  };

  return (
    <TextField
      helperText={getErrorMessage()}
      error={hasError()}
      data-testid={dataTestId}
      onChange={onChange}
      onBlur={() => setTouched(true)}
      value={value}
      InputProps={{
        onKeyDown,
      }}
      {...rest}
    />
  );
};
